import { signal } from '@preact/signals';
import type { Route } from '../backend/route';

export const routeStore = signal<Route | null>(null);
